import ApolloClient from "@/apollo-client";
import currentUser from "@/Graphql/GetCurrentUser.query.graphql";

export const getCurrentUser = async () => {
  const { data } = await ApolloClient.query({
    query: currentUser,
    fetchPolicy: "network-only",
  });
  return data;
};
